import React, { Fragment } from 'react';
import { inject, observer } from "mobx-react";
import "../../assets/scss/pages/app-chat.scss";
import { withFirebase } from "../../services/Firebase";
const mql = window.matchMedia(`(min-width: 992px)`);
import {PageFlip} from 'page-flip';
import '../../assets/scss/pages/app-library.scss'
import { ChevronLeft, ChevronRight } from "react-feather";
import { Button } from "reactstrap";


@withFirebase
@inject("contentViewerStore")
@observer
class ContentViewer extends React.Component {
  constructor(props) {
    super(props);
    this.pageFlip= null;
    this.state = {
      width: innerWidth,
      height: parseInt(innerWidth*(0.8714)) > innerHeight ? innerHeight : parseInt(innerWidth*(0.8714)),
      load: true,
      currentPage: 1
    };
  }

  componentDidMount() {
    const { contentViewerStore, match } = this.props;
    const { sharecode } = match.params;
    contentViewerStore.loadDocPage(sharecode);
  }

  loadImages = (docsPage) => {
    this.setState({load: false})
    this.pageFlip = new PageFlip(document.getElementById('canvas-image-viewer'),
      {
          width: this.state.width - 20,
          height: this.state.height - 30,
          showCover: true,
          flippingTime: 700,
          size: "stretch",
          minWidth: 310, 
          maxWidth: 1400,
          minHeight: 400,
          maxHeight: 800
      }
    );
    this.pageFlip.loadFromImages(docsPage);
    this.pageFlip.on('flip', (e) => {
      this.setState({
        currentPage: e.data+1
      })
    })
  }

  next = () => {
    this.pageFlip.flipNext();
  }

  prev = () => {
    this.pageFlip.flipPrev();    
  }

  render(){
    const { docsPage } = this.props.contentViewerStore;
    if (docsPage && docsPage.length && this.state.load){  
      this.loadImages(docsPage)
    }
    return(
      <Fragment>
        <div>
          <h6>toolbar section</h6>
        </div>
        <div className="content-viewer">
        <div id="canvas-image-viewer" className="canvas-container">
        </div>
        { docsPage && docsPage.length ? 
          <div className="file-preview-control" style={{border: 'none'}}>
            <div className="mt-2 mb-2">
              <Button
                size="sm"
                outline
                color="primary"
                onClick={this.prev} 
              >
                <ChevronLeft size={15} />
              </Button>
              <span className="mr-1 ml-1" style={{color: 'white'}}>{this.state.currentPage}/{this.pageFlip.getPageCount()}</span>
              <Button
                size="sm"
                outline
                color="primary"
                onClick={this.next}
              >
                <ChevronRight size={15} />
              </Button>
            </div>
          </div>
        : <div></div> }
      </div>
      </Fragment>
    )
  }
}
export default ContentViewer;
